var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounterpartiesTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C8 15.4477 8.44772 15 9 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H9C8.44772 17 8 16.5523 8 16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.0156C8.44772 12.0156 8 12.4633 8 13.0156C8 13.5679 8.44772 14.0156 9 14.0156H15C15.5523 14.0156 16 13.5679 16 13.0156C16 12.4633 15.5523 12.0156 15 12.0156H9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2C5.34315 2 4 3.34315 4 5V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V12C20 11.1691 19.6622 10.4171 19.1164 9.8738C19.0874 9.83465 19.0551 9.79715 19.0196 9.76164L12.0977 2.83977C12.0478 2.78987 11.994 2.74635 11.9372 2.70921C11.4145 2.26678 10.7384 2 10 2H7ZM6 5C6 4.44772 6.44772 4 7 4H10C10.5523 4 11 4.44772 11 5V8C11 9.65685 12.3431 11 14 11H17C17.5523 11 18 11.4477 18 12V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V5ZM13 6.57046V8C13 8.55228 13.4477 9 14 9H15.4295L13 6.57046Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterpartiesTab);
export default __webpack_public_path__ + "static/media/counterparties-tab.edb78fdd.svg";
export { ForwardRef as ReactComponent };